import { Injectable } from '@angular/core';

import { LoggerMetadata, MetadataService } from './metadata';
import { LoggerConfig } from '../logger-config';

@Injectable()
export class BaseMetadataService implements MetadataService {
  public getMetadata(level: number, _config: LoggerConfig, message?: any, additional?: any[]): LoggerMetadata {
    const metadata: LoggerMetadata = {
      additional,
      level,
      message,
      timestamp: new Date().toISOString()
    };

    return metadata;
  }
}
